exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Employees__employeeTable__219JO {\n    text-align: left;\n    border-collapse: collapse;\n    margin-bottom: 2rem;\n}\n.Employees__employeeTable__219JO thead tr th {\n    border: none;\n    margin: 0;\n    padding: 5px;\n}\n.Employees__employeeTable__219JO tbody tr td svg {\n    padding: 0 4px;\n    cursor: pointer;\n}\n.Employees__employeeTable__219JO tbody tr td {\n    padding: 5px;\n}\n.Employees__employeeTable__219JO tbody tr {\n    background-color: white;\n}\n.Employees__employeeTable__219JO tbody tr:hover {\n    background-color: #ebf6ff;\n}", ""]);

// exports
exports.locals = {
	"employeeTable": "Employees__employeeTable__219JO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/containers/Company/Employees/Employees.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/containers/Company/Employees/Employees.css
// module chunks = 0